import React from 'react';
import { Button, Form } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

const FilterSection = ({ 
  startDate, setStartDate, 
  endDate, setEndDate, 
  categoryFilter, setCategoryFilter,
  payeeFilter, setPayeeFilter,
  classFilter, setClassFilter,
  descriptionFilter, setDescriptionFilter,
  onlyUncategorized, setOnlyUncategorized,
  postingFilter, setPostingFilter,
  limit, setLimit, 
  accounts, 
  payees,
  classes,
  setPage, 
  transactions, 
  total, 
  pages, 
  fetchTransactions 
}) => {
  return (
    <div className="card shadow-sm mb-4 border-0">
      <div className="card-body p-3">
        {/* Posting Status Tabs */}
        <div className="d-flex mb-3 border-bottom pb-2">
          <div 
            className={`mr-3 px-3 py-2 rounded font-weight-bold cursor-pointer transition-all ${postingFilter === 'pending' ? 'bg-warning text-dark shadow-sm' : 'bg-light text-muted'}`}
            style={{ fontSize: '0.8rem', cursor: 'pointer', transition: 'all 0.2s' }}
            onClick={() => { setPostingFilter('pending'); setPage(1); }}
          >
            <i className="fas fa-clock mr-1"></i> Pending
          </div>
          <div 
            className={`mr-3 px-3 py-2 rounded font-weight-bold cursor-pointer transition-all ${postingFilter === 'posted' ? 'bg-success text-white shadow-sm' : 'bg-light text-muted'}`}
            style={{ fontSize: '0.8rem', cursor: 'pointer', transition: 'all 0.2s' }}
            onClick={() => { setPostingFilter('posted'); setPage(1); }}
          >
            <i className="fas fa-check-circle mr-1"></i> Posted
          </div>
          <div 
            className={`px-3 py-2 rounded font-weight-bold cursor-pointer transition-all ${postingFilter === 'excluded' ? 'bg-danger text-white shadow-sm' : 'bg-light text-muted'}`}
            style={{ fontSize: '0.8rem', cursor: 'pointer', transition: 'all 0.2s' }}
            onClick={() => { setPostingFilter('excluded'); setPage(1); }}
          >
            <i className="fas fa-ban mr-1"></i> Excluded
          </div>
        </div>

        {/* Row 1: Searchable Text Boxes */}
        <div className="row no-gutters align-items-center mb-3">
          <div className="col-md-4 pr-2">
            <div className="position-relative">
                <Form.Control 
                    type="text" 
                    size="sm"
                    className="border-0 bg-light pr-4" 
                    style={{ fontSize: '0.75rem' }}
                    value={descriptionFilter} 
                    onChange={e => { setDescriptionFilter(e.target.value); setPage(1); }} 
                    onKeyDown={e => { if (e.key === 'Enter') fetchTransactions(); }}
                    placeholder="Search description..." 
                />
                <i className="fas fa-search position-absolute text-muted" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.65rem' }}></i>
            </div>
          </div>
          <div className="col-md-2 pr-2">
            <SearchableSelect 
              options={[
                  { value: '', label: 'All Payees' },
                  ...(payees ? payees.map(p => ({ value: p._id, label: p.name, sublabel: p.type })) : [])
              ]}
              value={payeeFilter}
              onChange={e => { setPayeeFilter(e.target.value); setPage(1); }}
              placeholder="Filter by Payee..."
            />
          </div>
          <div className="col-md-2 pr-2">
            <SearchableSelect 
              options={[
                  { value: '', label: 'All Classes' },
                  ...(classes ? classes.map(c => ({ value: c._id, label: c.name })) : [])
              ]}
              value={classFilter}
              onChange={e => { setClassFilter(e.target.value); setPage(1); }}
              placeholder="Filter by Class..."
            />
          </div>
          <div className="col-md-2 pr-2">
            <SearchableSelect 
              options={[
                  { value: '', label: 'All Categories' },
                  ...accounts.filter(acc => ['Income', 'Expense', 'Cost of Goods Sold', 'Other Income', 'Other Expense'].includes(acc.type)).map(acc => ({ value: acc.name, label: acc.name, sublabel: acc.type }))
              ]}
              value={categoryFilter}
              onChange={e => { setCategoryFilter(e.target.value); setPage(1); }}
              placeholder="Filter by Category..."
            />
          </div>
          <div className="col-md-2">
            <Button variant="outline-secondary" size="sm" className="w-100 border-0 bg-light text-muted font-weight-bold" onClick={() => {
              setStartDate('');
              setEndDate('');
              setCategoryFilter('');
              setPayeeFilter('');
              setClassFilter('');
              setDescriptionFilter('');
              setOnlyUncategorized(false);
              setPostingFilter('pending');
              setPage(1);
            }} title="Clear all filters" style={{ fontSize: '0.75rem' }}>
                <i className="fas fa-times-circle mr-1"></i> Clear All
            </Button>
          </div>
        </div>

        {/* Row 2: Secondary Controls (Date, Stats, Rows) */}
        <div className="row align-items-center">
          <div className="col-md-5">
            <div className="d-flex align-items-center">
                <div className="input-group input-group-sm mr-3" style={{ width: '180px' }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text border-0 bg-transparent text-muted small">From</span>
                    </div>
                    <input type="month" className="form-control border-0 bg-light" style={{ fontSize: '0.75rem' }} value={startDate} onChange={e => { setStartDate(e.target.value); setPage(1); }} />
                </div>
                <div className="input-group input-group-sm mr-3" style={{ width: '180px' }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text border-0 bg-transparent text-muted small">To</span>
                    </div>
                    <input type="month" className="form-control border-0 bg-light" style={{ fontSize: '0.75rem' }} value={endDate} onChange={e => { setEndDate(e.target.value); setPage(1); }} />
                </div>
                <div className="form-check mb-0">
                    <input type="checkbox" className="form-check-input" id="uncategorizedCheck" checked={onlyUncategorized} onChange={e => { setOnlyUncategorized(e.target.checked); setPage(1); }} />
                    <label className="form-check-label small text-muted" htmlFor="uncategorizedCheck" style={{ fontSize: '0.7rem' }}>Only Uncategorized</label>
                </div>
            </div>
          </div>
          
          <div className="col-md-7 text-right">
            <div className="d-inline-flex align-items-center">
                <span className="small text-muted mr-3" style={{ fontSize: '0.7rem' }}>
                    Showing <strong>{transactions?.length || 0}</strong> of <strong>{total}</strong> (Pages: {pages})
                </span>
                <div className="input-group input-group-sm mr-2" style={{ width: '100px' }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text border-0 bg-transparent text-muted small">Rows</span>
                    </div>
                    <select className="form-control border-0 bg-light" style={{ fontSize: '0.7rem' }} value={limit} onChange={e => { setLimit(parseInt(e.target.value)); setPage(1); }}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <Button variant="link" size="sm" className="text-primary p-0 ml-2" onClick={fetchTransactions} title="Refresh">
                    <i className="fas fa-sync-alt"></i>
                </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;
